import { Component, HostBinding, Input, OnInit, TemplateRef } from '@angular/core';

@Component({
  selector: 'suka-page',
  template: `
    <suka-page-header [breadcrumb]="breadcrumb" [title]="title" [subtitle]="subtitle" [actions]="actions"></suka-page-header>

    <ng-content></ng-content>
  `
})
export class Page implements OnInit {
  @Input() fluid: false;
  @HostBinding('class.page--narrow') @Input() narrow = false;

  @HostBinding('class.page') default = true;
  @HostBinding('class.page--fluid') _fluid = false;

  @Input() title: string | TemplateRef<any>;

  @Input() subtitle: string;

  @Input() actions: TemplateRef<any>;

  @Input() breadcrumb = true;

  public ngOnInit() {
    if (this.fluid) {
      this._fluid = true;
      this.default = false;
    }
  }
}
